var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _vm.isTypeCustomer && !_vm.hasPotentialDates
        ? _c("div", { staticClass: "font-weight-bold" }, [
            _vm._v("\n\t\tBitte schlage neue Termine vor:\n\t")
          ])
        : _c("div", { staticClass: "font-weight-bold" }, [
            _vm._v("Termin wählen:")
          ]),
      _vm._v(" "),
      _vm.hasPotentialDates
        ? _vm._l(_vm.appointment.potentialDates, function(potentialDate) {
            return _c(
              "div",
              { key: potentialDate.id },
              [
                _c(
                  "b-form-checkbox",
                  {
                    attrs: {
                      checked: _vm.chosenDate === potentialDate,
                      disabled:
                        _vm.datesNotPossible || _vm.isDatePastDue(potentialDate)
                    },
                    on: {
                      change: function($event) {
                        return _vm.onChosenDateChanged($event, potentialDate)
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "text-line-through":
                            _vm.datesNotPossible ||
                            _vm.isDatePastDue(potentialDate)
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm._f("fullDateTime")(potentialDate.timeStamp)
                            ) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _vm.hasPotentialDates && !_vm.allDatesPastDue
            ? [
                _c(
                  "b-form-checkbox",
                  {
                    on: { change: _vm.onDatesNotPossibleChanged },
                    model: {
                      value: _vm.datesNotPossible,
                      callback: function($$v) {
                        _vm.datesNotPossible = $$v
                      },
                      expression: "datesNotPossible"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\tIch kann an keinem dieser Termine\n\t\t\t"
                    )
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.datesNotPossible || !_vm.hasPotentialDates || _vm.allDatesPastDue
            ? _c(
                "div",
                { staticClass: "mt-3" },
                [
                  _vm.isTypeApplicant && _vm.allDatesPastDue
                    ? _c("JonInfo", {
                        staticClass: "mb-3",
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "message",
                              fn: function() {
                                return [
                                  _vm._v(
                                    "\n\t\t\t\t\tDu hast alle Terminvorschläge versäumt, die an dich gesendet wurden. Sende jetzt\n\t\t\t\t\tTerminvorschläge an den Arbeitgeber oder teile mit, dass du nach wir vor interessiert bist und\n\t\t\t\t\tneue Terminvorschläge möchtest.\n\t\t\t\t"
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1433913539
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isTypeApplicant
                    ? _c("RadioGroup", {
                        staticClass: "mt-3",
                        attrs: { options: _vm.counterProposalTypeOptions },
                        on: { input: _vm.emitChangeEvent },
                        model: {
                          value: _vm.counterProposalType,
                          callback: function($$v) {
                            _vm.counterProposalType = $$v
                          },
                          expression: "counterProposalType"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCounterProposalTypeSuggestions
                    ? _c(
                        "FormGroup",
                        { staticClass: "mt-3" },
                        [
                          _c("PotentialDates", {
                            attrs: { "max-time": _vm.counterProposalMaxTime },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.counterProposalDates,
                              callback: function($$v) {
                                _vm.counterProposalDates = $$v
                              },
                              expression: "counterProposalDates"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }